var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"carSaleTable",attrs:{"pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"paging":"","columns":_vm.columns,"rows":_vm.carSaleList,"stripe":false,"selection":false,"height":"500px"},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }